const ITEMS = [
  "Rope Access",
  "NR-35",
  "Sem Andaimes",
  "São Paulo",
  "Acabamento Premium",
  "Prazo Curto",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 bg-black py-5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-display text-2xl font-black uppercase tracking-tight text-white/15"
              >
                <span className="px-6">{item}</span>
                <span className="h-2 w-2 bg-krono" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
